import { Component, OnInit } from '@angular/core';
import { UserService } from './services/user.service';
import { AdminService } from './services/admin.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ClientApp';

  // Menu / UI states
  public shouldShow = false;
  public SubmenuShow1 = false;
  public SubmenuShow2 = false;
  public SubmenuShow3 = false;
  public SubmenuShow4 = false;
  public SubmenuShow5 = false;
  public SubmenuShow6 = false;
  public SubmenuShow7 = false;
  public SubmenuShow8 = false;
  public SubmenuShow9 = false;
  public SubmenuShow10 = false;
  public SubmenuShow11 = false;
  public SubmenuShow12 = false;

  contentLoaded = false;
  user: any = null;  // user starts as null

  constructor(
    private userService: UserService,
    private adminService: AdminService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
    }, 2000);
  }

  toggleMenu() {
    const user = this.userService.getUserInfo();
    if (user && user.id > 0) {
      this.userService.changeMemberPhoto(user.picture);
    }
  }

  onActivate(event?: any) {
    window.scroll(0, 0);
  }
}




// import { Component, OnInit } from '@angular/core';
// import { UserService } from './services/user.service';
// import { AdminService } from './services/admin.service';
// import { environment } from 'src/environments/environment';
// import { Observable, of } from 'rxjs';
// import { map, catchError } from 'rxjs/operators';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.css']
// })
// export class AppComponent implements OnInit {
//   title = 'ClientApp';

//   // Menu / UI states
//   public shouldShow = false;
//   public SubmenuShow1 = false;
//   public SubmenuShow2 = false;
//   public SubmenuShow3 = false;
//   public SubmenuShow4 = false;
//   public SubmenuShow5 = false;
//   public SubmenuShow6 = false;
//   public SubmenuShow7 = false;
//   public SubmenuShow8 = false;
//   public SubmenuShow9 = false;
//   public SubmenuShow10 = false;
//   public SubmenuShow11 = false;
//   public SubmenuShow12 = false;

//   contentLoaded = false;
//   user: any = null;  // user starts as null
//   verifyLoaderRedirect: boolean = false;

//   constructor(
//     private userService: UserService,
//     private adminService: AdminService
//   ) { }

//   ngOnInit() {
//     if (environment.isPingEnable) {
//       if (window.location.href.includes("callback")) this.verifyLoaderRedirect = true;
//       else
//         this.adminService.verifyPingAccessToken().pipe(
//           map((result: any) => {
//             if (!result?.active) this.userService.logout();
//             else this.verifyLoaderRedirect = true;
//             return true;
//           }),
//           catchError(() => {
//             this.userService.logout();
//             this.verifyLoaderRedirect = true;
//             return '';
//           })
//         );
//     } else this.verifyLoaderRedirect = true;

//     setTimeout(() => {
//       this.contentLoaded = true;
//     }, 2000);
//   }

//   toggleMenu() {
//     const user = this.userService.getUserInfo();
//     if (user && user.id > 0) {
//       this.userService.changeMemberPhoto(user.picture);
//     }
//   }

//   onActivate(event?: any) {
//     window.scroll(0, 0);
//   }
// }